module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"category-item":{"image-alt":"Kategoriforhåndsvisningsbillede %title%"}},"de":{"category-item":{"image-alt":"Kategorievorschaubild %title%"}},"fr":{"category-item":{"image-alt":"Image d’aperçu de catégorie %title%"}},"nl":{"category-item":{"image-alt":"Categorievoorbeeldafbeelding %title%"}}}')
  delete Component.options._Ctor
}
